var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",staticStyle:{"width":"100% !important"},attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }